import React, { useEffect, useState, useCallback } from "react";
import {
  Form, Input, Button, Card, Tabs, message, Spin,
  Alert, Tag, Modal, Tooltip, Badge
} from "antd";
import {
  PlusOutlined, CalendarOutlined, TagOutlined,
  EditOutlined, DeleteOutlined, EyeOutlined,
  CrownOutlined, CheckCircleOutlined, CloseCircleOutlined,
  ReloadOutlined, StarFilled, RocketOutlined,
  PhoneOutlined, UserOutlined, ThunderboltOutlined,
  FilterOutlined, BankOutlined, WalletOutlined,
  CopyOutlined, EyeInvisibleOutlined, SaveOutlined,
  ExclamationCircleOutlined, InfoCircleOutlined,
  SafetyCertificateOutlined, CreditCardOutlined,
  ClockCircleOutlined
} from '@ant-design/icons';
import {
  updateDeveloperBankDetails,
  getDeveloperDashboard, // ✅ Yeh available hai
  PostChargesGet,
  PostChargesPost,
  PostChargesUpdate,
  PostChargesRemove,
} from "../../../../Api/CoreApi";
import "./DeveloperBankDetails.css";

function DeveloperBankDetails() {
  const [form] = Form.useForm();
  const [upiForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);
  const [activeTab, setActiveTab] = useState("bank");
  const [isEditingBank, setIsEditingBank] = useState(false);
  const [isEditingUpi, setIsEditingUpi] = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [refreshing, setRefreshing] = useState(false);

  // ✅ CORRECTED: Use getDeveloperDashboard instead
  const fetchBankDetails = useCallback(async (showRefresh = false) => {
    try {
      if (showRefresh) setRefreshing(true);
      else setLoading(true);

      const data = await getDeveloperDashboard();

      console.log("📦 Full Response:", data);
      console.log("📦 bank_details:", data?.bank_details);

      if (data) {
        // ✅ FIX - bank_details object se lo (backend se ye aata hai)
        const bankAccount =
          data.bank_details?.bank_account ||
          data.bank_account ||
          "";

        const ifscCode =
          data.bank_details?.ifsc_code ||
          data.ifsc_code ||
          "";

        const upiId =
          data.bank_details?.upi_id ||
          data.upi_id ||
          "";

        // ✅ Default values filter karo (empty dikhao)
        const cleanBankAccount =
          bankAccount === 'Account Number' || !bankAccount
            ? ''
            : bankAccount;

        const cleanIfsc =
          ifscCode === 'SBIN0989054' || !ifscCode
            ? ''
            : ifscCode;

        const cleanUpi =
          upiId === 'upi_id.oksbi' || !upiId
            ? ''
            : upiId;

        const bankData = {
          bank_account: cleanBankAccount,
          ifsc_code: cleanIfsc,
          upi_id: cleanUpi,
          username: data.user_info?.username || data.username || "Developer",
          contact: data.user_info?.contact || data.contact || "",
          bank_updated_at: data.bank_updated_at || data.updated_at || new Date(),
        };

        console.log("✅ Clean bankData:", bankData);

        setBankDetails(bankData);

        // ✅ setTimeout wrap - warning fix
        setTimeout(() => {
          try {
            form.setFieldsValue({
              bank_account: bankData.bank_account || "",
              ifsc_code: bankData.ifsc_code || "",
            });
          } catch (e) {
            console.log("Bank form not ready");
          }

          try {
            upiForm.setFieldsValue({ upi_id: bankData.upi_id || "" });
          } catch (e) {
            console.log("UPI form not ready");
          }
        }, 100);

        // ✅ Auto-open edit mode if empty
        if (!bankData.bank_account) setIsEditingBank(true);
        if (!bankData.upi_id) setIsEditingUpi(true);
      }
    } catch (error) {
      console.error("Error fetching bank details:", error);
      message.error("Failed to fetch bank details");
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, [form, upiForm]);

  useEffect(() => {
    fetchBankDetails();
  }, [fetchBankDetails]);

  
  // Mask account number
  const maskAccountNumber = (acc) => {
    if (!acc) return "";
    if (showAccount) return acc.replace(/(\d{4})/g, "$1 ").trim();
    const last4 = acc.slice(-4);
    return `●●●● ●●●● ${last4}`;
  };

  // Copy to clipboard
  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text).then(() => {
      message.success(`${label} copied!`);
    });
  };

  // Handle bank submit with confirmation
  const handleBankSubmit = async (values) => {
    Modal.confirm({
      title: "Confirm Bank Details",
      icon: <ExclamationCircleOutlined style={{ color: "#ff0055" }} />,
      content: (
        <div>
          <p>Please verify your details:</p>
          <p><strong>Account:</strong> {values.bank_account}</p>
          <p><strong>IFSC:</strong> {values.ifsc_code.toUpperCase()}</p>
          <p style={{ color: "#ff4d88", fontSize: 12, marginTop: 8 }}>
            ⚠️ Incorrect details may cause withdrawal failures.
          </p>
        </div>
      ),
      okText: "Confirm & Save",
      okButtonProps: {
        style: { background: "linear-gradient(135deg, #ff0055, #ff4d88)", border: "none" },
      },
      onOk: async () => {
        try {
          setSaving(true);
          const response = await updateDeveloperBankDetails({
            bank_account: values.bank_account,
            ifsc_code: values.ifsc_code.toUpperCase(),
            upi_id: bankDetails?.upi_id || "",
          });
          if (response?.success) {
            Modal.success({
              title: "✅ Bank Details Updated!",
              content: "Your bank details have been saved successfully.",
              okButtonProps: {
                style: { background: "linear-gradient(135deg, #ff0055, #ff4d88)", border: "none" },
              },
            });
            setIsEditingBank(false);
            fetchBankDetails(true);
          }
        } catch (error) {
          message.error(error.message || "Failed to update");
        } finally {
          setSaving(false);
        }
      },
    });
  };

  // Handle UPI submit with confirmation
  const handleUpiSubmit = async (values) => {
    Modal.confirm({
      title: "Confirm UPI ID",
      icon: <ExclamationCircleOutlined style={{ color: "#ff0055" }} />,
      content: (
        <div>
          <p>Please verify your UPI ID:</p>
          <p><strong>{values.upi_id}</strong></p>
          <p style={{ color: "#ff4d88", fontSize: 12, marginTop: 8 }}>
            ⚠️ Incorrect UPI may cause payment failures.
          </p>
        </div>
      ),
      okText: "Confirm & Save",
      okButtonProps: {
        style: { background: "linear-gradient(135deg, #ff0055, #ff4d88)", border: "none" },
      },
      onOk: async () => {
        try {
          setSaving(true);
          const response = await updateDeveloperBankDetails({
            upi_id: values.upi_id,
            bank_account: bankDetails?.bank_account || "",
            ifsc_code: bankDetails?.ifsc_code || "",
          });
          if (response?.success) {
            Modal.success({
              title: "✅ UPI Updated!",
              content: "Your UPI ID has been saved successfully.",
              okButtonProps: {
                style: { background: "linear-gradient(135deg, #ff0055, #ff4d88)", border: "none" },
              },
            });
            setIsEditingUpi(false);
            fetchBankDetails(true);
          }
        } catch (error) {
          message.error(error.message || "Failed to update");
        } finally {
          setSaving(false);
        }
      },
    });
  };

  // Completion percentage
  const getCompletionStatus = () => {
    let done = 0;
    let total = 2;
    if (bankDetails?.bank_account) done++;
    if (bankDetails?.upi_id) done++;
    return { done, total, percent: Math.round((done / total) * 100) };
  };

  const completion = getCompletionStatus();

  // Tab items
  const tabItems = [
    {
      key: "bank",
      label: (
        <span className="dev-bank-tab-label">
          <BankOutlined /> Bank Account
          {bankDetails?.bank_account && (
            <Tag className="dev-bank-verified-tag">
              <CheckCircleOutlined /> Set
            </Tag>
          )}
        </span>
      ),
      children: (
        <div className="dev-bank-tab-content">
          {/* VIEW MODE */}
          {bankDetails?.bank_account && !isEditingBank && (
            <div className="dev-bank-current-details">
              <div className="dev-bank-detail-row">
                <div className="dev-bank-detail-icon">
                  <BankOutlined />
                </div>
                <div className="dev-bank-detail-info">
                  <div className="dev-bank-detail-label">Account Number</div>
                  <div className="dev-bank-detail-value">
                    {maskAccountNumber(bankDetails.bank_account)}
                  </div>
                </div>
                <div className="dev-bank-detail-actions">
                  <Tooltip title={showAccount ? "Hide" : "Show"}>
                    <Button
                      type="text"
                      size="small"
                      className="dev-bank-detail-action-btn"
                      icon={showAccount ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                      onClick={() => setShowAccount(!showAccount)}
                    />
                  </Tooltip>
                  <Tooltip title="Copy">
                    <Button
                      type="text"
                      size="small"
                      className="dev-bank-detail-action-btn"
                      icon={<CopyOutlined />}
                      onClick={() => copyToClipboard(bankDetails.bank_account, "Account number")}
                    />
                  </Tooltip>
                </div>
              </div>

              <div className="dev-bank-detail-row">
                <div className="dev-bank-detail-icon">
                  <SafetyCertificateOutlined />
                </div>
                <div className="dev-bank-detail-info">
                  <div className="dev-bank-detail-label">IFSC Code</div>
                  <div className="dev-bank-detail-value dev-bank-ifsc">
                    {bankDetails.ifsc_code}
                  </div>
                </div>
                <div className="dev-bank-detail-actions">
                  <Tooltip title="Copy">
                    <Button
                      type="text"
                      size="small"
                      className="dev-bank-detail-action-btn"
                      icon={<CopyOutlined />}
                      onClick={() => copyToClipboard(bankDetails.ifsc_code, "IFSC code")}
                    />
                  </Tooltip>
                </div>
              </div>

              <Button
                className="dev-bank-edit-btn"
                icon={<EditOutlined />}
                onClick={() => setIsEditingBank(true)}
                block
              >
                Edit Bank Details
              </Button>
            </div>
          )}

          {/* EDIT MODE */}
          {(isEditingBank || !bankDetails?.bank_account) && (
            <Form
              form={form}
              layout="vertical"
              onFinish={handleBankSubmit}
              className="dev-bank-form"
            >
              <Alert
                message="Bank Account Details"
                description="Enter your bank account number and IFSC code carefully. These details will be used for withdrawals."
                type="info"
                showIcon
                icon={<InfoCircleOutlined style={{ color: "#ff0055" }} />}
                className="dev-bank-alert"
              />

              <Form.Item
                label={
                  <span className="dev-bank-form-label">
                    <CreditCardOutlined /> Account Number
                  </span>
                }
                name="bank_account"
                rules={[
                  { required: true, message: "Account number is required" },
                  { min: 9, message: "At least 9 digits" },
                  { max: 20, message: "Max 20 digits" },
                  { pattern: /^[0-9]+$/, message: "Numbers only" },
                ]}
              >
                <Input
                  size="large"
                  placeholder="Enter bank account number"
                  className="dev-bank-input"
                  prefix={<BankOutlined className="dev-bank-input-icon" />}
                  maxLength={20}
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="dev-bank-form-label">
                    <SafetyCertificateOutlined /> IFSC Code
                  </span>
                }
                name="ifsc_code"
                rules={[
                  { required: true, message: "IFSC code is required" },
                  {
                    pattern: /^[A-Z]{4}0[A-Z0-9]{6}$/,
                    message: "Invalid format (e.g., SBIN0001234)",
                  },
                ]}
                normalize={(v) => (v ? v.toUpperCase() : v)}
              >
                <Input
                  size="large"
                  placeholder="e.g., SBIN0001234"
                  maxLength={11}
                  className="dev-bank-input"
                  prefix={<SafetyCertificateOutlined className="dev-bank-input-icon" />}
                />
              </Form.Item>

              <div className="dev-bank-form-actions">
                {bankDetails?.bank_account && (
                  <Button
                    className="dev-bank-cancel-btn"
                    onClick={() => {
                      setIsEditingBank(false);
                      form.setFieldsValue({
                        bank_account: bankDetails.bank_account,
                        ifsc_code: bankDetails.ifsc_code,
                      });
                    }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  icon={<SaveOutlined />}
                  loading={saving}
                  className="dev-bank-save-btn"
                >
                  Save Bank Details
                </Button>
              </div>
            </Form>
          )}
        </div>
      ),
    },
    {
      key: "upi",
      label: (
        <span className="dev-bank-tab-label">
          <WalletOutlined /> UPI ID
          {bankDetails?.upi_id && (
            <Tag className="dev-bank-verified-tag">
              <CheckCircleOutlined /> Set
            </Tag>
          )}
        </span>
      ),
      children: (
        <div className="dev-bank-tab-content">
          {/* VIEW MODE */}
          {bankDetails?.upi_id && !isEditingUpi && (
            <div className="dev-bank-current-details">
              <div className="dev-bank-detail-row">
                <div className="dev-bank-detail-icon dev-bank-detail-icon-upi">
                  <WalletOutlined />
                </div>
                <div className="dev-bank-detail-info">
                  <div className="dev-bank-detail-label">UPI ID</div>
                  <div className="dev-bank-detail-value dev-bank-upi">
                    {bankDetails.upi_id}
                  </div>
                </div>
                <div className="dev-bank-detail-actions">
                  <Tooltip title="Copy">
                    <Button
                      type="text"
                      size="small"
                      className="dev-bank-detail-action-btn"
                      icon={<CopyOutlined />}
                      onClick={() => copyToClipboard(bankDetails.upi_id, "UPI ID")}
                    />
                  </Tooltip>
                </div>
              </div>

              <Button
                className="dev-bank-edit-btn"
                icon={<EditOutlined />}
                onClick={() => setIsEditingUpi(true)}
                block
              >
                Edit UPI ID
              </Button>
            </div>
          )}

          {/* EDIT MODE */}
          {(isEditingUpi || !bankDetails?.upi_id) && (
            <Form
              form={upiForm}
              layout="vertical"
              onFinish={handleUpiSubmit}
              className="dev-bank-form"
            >
              <Alert
                message="UPI ID for Fast Withdrawals"
                description="UPI transfers are usually faster than bank transfers. Make sure your UPI ID is correct."
                type="info"
                showIcon
                icon={<InfoCircleOutlined style={{ color: "#ff0055" }} />}
                className="dev-bank-alert"
              />

              <Form.Item
                label={
                  <span className="dev-bank-form-label">
                    <WalletOutlined /> UPI ID
                  </span>
                }
                name="upi_id"
                rules={[
                  { required: true, message: "UPI ID is required" },
                  {
                    pattern: /^[\w.-]+@[\w]+$/,
                    message: "Invalid UPI format (e.g., name@paytm)",
                  },
                ]}
              >
                <Input
                  size="large"
                  placeholder="yourname@paytm, mobile@ybl"
                  className="dev-bank-input"
                  prefix={<WalletOutlined className="dev-bank-input-icon" />}
                />
              </Form.Item>

              <div className="dev-bank-upi-examples">
                <div className="dev-bank-upi-title">
                  <InfoCircleOutlined /> Common UPI Formats:
                </div>
                <div className="dev-bank-upi-list">
                  {["yourname@paytm", "mobile@ybl", "name@okhdfcbank", "name@apl", "name@ibl"].map(
                    (upi) => (
                      <span
                        key={upi}
                        className="dev-bank-upi-badge"
                        onClick={() => upiForm.setFieldsValue({ upi_id: upi })}
                        style={{ cursor: "pointer" }}
                      >
                        {upi}
                      </span>
                    )
                  )}
                </div>
              </div>

              <div className="dev-bank-form-actions">
                {bankDetails?.upi_id && (
                  <Button
                    className="dev-bank-cancel-btn"
                    onClick={() => {
                      setIsEditingUpi(false);
                      upiForm.setFieldsValue({ upi_id: bankDetails.upi_id });
                    }}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  type="primary"
                  htmlType="submit"
                  size="large"
                  icon={<SaveOutlined />}
                  loading={saving}
                  className="dev-bank-save-btn"
                >
                  Save UPI ID
                </Button>
              </div>
            </Form>
          )}
        </div>
      ),
    },
  ];

  // Loading
  if (loading) {
    return (
      <div className="dev-bank-page">
        <div className="dev-bank-loading-wrap">
          <Spin size="large" />
          <p>Loading bank details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="dev-bank-page">
      {/* ===== HEADER ===== */}
      <div className="dev-bank-header">
        <div className="dev-bank-header-icon">
          <BankOutlined />
        </div>
        <div className="dev-bank-header-content">
          <h1 className="dev-bank-header-title">Payment Details</h1>
          <p className="dev-bank-header-subtitle">
            Manage your bank account and UPI details for withdrawals
          </p>
        </div>
        <div className="dev-bank-header-actions">
          <Tooltip title="Refresh">
            <Button
              className="dev-bank-refresh-btn"
              icon={<ReloadOutlined spin={refreshing} />}
              onClick={() => fetchBankDetails(true)}
            />
          </Tooltip>
          <div className="dev-bank-completion-badge">
            <span className="dev-bank-completion-text">
              {completion.percent}% Complete
            </span>
            <div className="dev-bank-completion-bar">
              <div
                className="dev-bank-completion-fill"
                style={{ width: `${completion.percent}%` }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ===== USER CARD ===== */}
      <Card className="dev-bank-user-card">
        <div className="dev-bank-user-info">
          <div className="dev-bank-user-avatar">
            {bankDetails?.username?.[0]?.toUpperCase() || "D"}
          </div>
          <div className="dev-bank-user-details">
            <div className="dev-bank-user-name">
              <UserOutlined /> {bankDetails?.username || "Developer"}
            </div>
            {bankDetails?.contact && (
              <div className="dev-bank-user-contact">
                <PhoneOutlined /> {bankDetails.contact}
              </div>
            )}
          </div>
          {bankDetails?.bank_updated_at && (
            <div className="dev-bank-updated-info">
              <ClockCircleOutlined /> Last Updated
              <div className="dev-bank-updated-date">
                {new Date(bankDetails.bank_updated_at).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </div>
            </div>
          )}
        </div>
      </Card>

      {/* ===== STATUS CARDS ===== */}
      <div className="dev-bank-status-cards">
        <div
          className={`dev-bank-status-card ${bankDetails?.bank_account ? "active" : "inactive"
            }`}
        >
          <div className="dev-bank-status-icon">
            <BankOutlined />
          </div>
          <div className="dev-bank-status-info">
            <div className="dev-bank-status-title">Bank Account</div>
            <div className="dev-bank-status-value">
              {bankDetails?.bank_account ? (
                <span className="dev-bank-status-set">
                  <CheckCircleOutlined /> Configured
                </span>
              ) : (
                <span className="dev-bank-status-notset">Not Set</span>
              )}
            </div>
          </div>
        </div>

        <div
          className={`dev-bank-status-card ${bankDetails?.upi_id ? "active" : "inactive"
            }`}
        >
          <div className="dev-bank-status-icon">
            <WalletOutlined />
          </div>
          <div className="dev-bank-status-info">
            <div className="dev-bank-status-title">UPI ID</div>
            <div className="dev-bank-status-value">
              {bankDetails?.upi_id ? (
                <span className="dev-bank-status-set">
                  <CheckCircleOutlined /> Configured
                </span>
              ) : (
                <span className="dev-bank-status-notset">Not Set</span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ===== COMPLETION ALERT ===== */}
      {completion.percent < 100 && (
        <Alert
          message={`Setup ${completion.percent}% Complete`}
          description={
            <span>
              {!bankDetails?.bank_account && "Add your bank account details. "}
              {!bankDetails?.upi_id && "Add your UPI ID for faster withdrawals."}
            </span>
          }
          type="warning"
          showIcon
          icon={<ExclamationCircleOutlined />}
          className="dev-bank-completion-alert"
        />
      )}

      {/* ===== MAIN CARD WITH TABS ===== */}
      <Card className="dev-bank-main-card">
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabItems}
          className="dev-bank-tabs"
        />
      </Card>

      {/* ===== SECURITY NOTE ===== */}
      <div className="dev-bank-security-note">
        <SafetyCertificateOutlined className="dev-bank-security-icon" />
        <div>
          <div className="dev-bank-security-title">Your data is secure</div>
          <div className="dev-bank-security-text">
            All payment details are encrypted and stored securely. We never share your
            financial information with third parties.
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeveloperBankDetails;